<script lang="ts">
import {domain} from "$lib/config/system";
export let articleName = '';
export let sectionName: 'case' | 'blog' = 'blog';
</script>

<div class="breadcrumbs-top">
	<div class="container">
		<ul class="list">
			<li><a href="{domain}/">Exoft</a></li>
			{#if sectionName === 'blog'}
				<li><a href="{domain}/blog/">Blog</a></li>
			{:else }
				<li><a href="{domain}/our-works/">Our works</a></li>
			{/if}
			<li>{articleName}</li>
		</ul>
	</div>
</div>

<style lang="scss">
  @import '$styles/vars';

  .breadcrumbs-top {
		width: 100%;
		color: $dark-grey;
		background-color: $main-black;
		position: absolute;
		top: 96px;
		padding: 10px 0;
		
		.list {
			font-size: 16px;
	  	font-weight: 500;
	  	line-height: 28px;
			display: flex;
			flex-wrap: wrap;
			list-style: none;
	  	margin: 0;
	  	padding: 0;
			li {
				&:not(:last-child) {
					a {
						color: $dark-grey;
					}
					&:after {
						content: '';
						display: inline-block;
						width: 0;
						height: 0;
						border-bottom: 4px solid transparent;
						border-top: 4px solid transparent;
						border-left: 5px solid $dark-grey;
						margin: 0 10px 1px;
					}
				}
			}
		}
	}
</style>
